import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { Schedule } from '@classes/holiday/schedule';

@Injectable({
  providedIn: 'root'
})
export class SchedulesService {
  schedulesListChanged = new Subject<Schedule[]>();
  private baseUrl: string = environment.apiUrl + 'schedules';
  private schedules: Schedule[];

  constructor(
    private http: HttpClient
  ) { }

  get(): Observable<Schedule[]> {
    return this.http.get<Schedule[]>(this.baseUrl)
      .pipe(
        map(schedules => {
          this.schedules = schedules.map(c => Schedule.fromObject(c));
          this.schedulesListChanged.next([...this.schedules]);
          return [...this.schedules];
        })
      );
  }

  getBySiteId(id: string): Observable<Schedule[]> {
    let httpParams = new HttpParams();

    httpParams = httpParams.append("siteId", id);

    return this.http.get<Schedule[]>(this.baseUrl, { params: httpParams })
      .pipe(
        map(schedules => {
          return schedules;
        })
      );
  }

  put(schedule: Schedule): Observable<Schedule> {
    return this.http.put<Schedule>(this.baseUrl, schedule)
      .pipe(
        tap(editedSchedule => {
          editedSchedule = Schedule.fromObject(editedSchedule);
          this.schedules = this.schedules.map(c => c.id === editedSchedule.id ? editedSchedule : c);
          this.schedulesListChanged.next([...this.schedules]);
        })
      );
  }

  post(schedule: Schedule): Observable<Schedule> {
    return this.http.post<Schedule>(this.baseUrl, schedule)
      .pipe(
        tap(createdSchedule => {
          createdSchedule = Schedule.fromObject(createdSchedule);
          this.schedules.push(createdSchedule);
          this.schedulesListChanged.next([...this.schedules]);
        })
      );
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`)
      .pipe(
        tap(() => {
          this.schedules = this.schedules.filter(c => c.id !== id);
          this.schedulesListChanged.next([...this.schedules]);
        })
      );
  }
}
